import { request } from './http'

export type EntityType =
  | 'character'
  | 'faction'
  | 'item'
  | 'location'
  | 'power'
  | 'event'
  | 'foreshadow'
  | 'chapter'
  | string

export interface EntityEdge {
  id: string
  source_type: EntityType
  source_id: string
  edge_type: string
  target_type: EntityType
  target_id: string
  weight: number | null
  confidence: number | null
  set_chapter: number | null
  end_chapter: number | null
  data: unknown
  source: string | null
}

export interface GraphNode {
  id: string
  type: EntityType
  label: string
}

export interface MemoryGraph {
  nodes: GraphNode[]
  edges: EntityEdge[]
}

export interface FetchEntityEdgesOptions {
  chapter?: number
  type?: string
}

export interface CausalEvent {
  id: number
  chapter_no: number
  event_type: string
  label: string
  caused_by: number | null
}

export interface FetchCausalityOptions {
  chapter?: number
  branchId?: string
}

export function fetchEntityEdges(projectId: string, opts: FetchEntityEdgesOptions = {}): Promise<EntityEdge[]> {
  const params = new URLSearchParams()
  params.set('project', projectId)
  if (opts.chapter !== undefined) params.set('chapter', String(opts.chapter))
  if (opts.type) params.set('type', opts.type)
  return request<EntityEdge[]>(`/v1/memory/edges?${params.toString()}`)
}

export function fetchGraph(projectId: string, chapter?: number): Promise<MemoryGraph> {
  const params = new URLSearchParams()
  params.set('project', projectId)
  if (chapter !== undefined && chapter > 0) params.set('chapter', String(chapter))
  return request<MemoryGraph>(`/v1/memory/graph?${params.toString()}`)
}

export function fetchCausality(projectId: string, opts: FetchCausalityOptions = {}): Promise<CausalEvent[]> {
  const params = new URLSearchParams()
  params.set('project', projectId)
  if (opts.chapter !== undefined) params.set('chapter', String(opts.chapter))
  if (opts.branchId) params.set('branch_id', opts.branchId)
  return request<CausalEvent[]>(`/v1/memory/causality?${params.toString()}`)
}

export function resolveForeshadowEdge(edgeId: string, chapter: number): Promise<void> {
  const params = new URLSearchParams()
  params.set('chapter', String(chapter))
  return request<void>(`/v1/memory/foreshadow/${encodeURIComponent(edgeId)}/resolve?${params.toString()}`, {
    method: 'POST',
  })
}
